export enum UnitTypeEnum {
  livingUnit = 0,
  serviceUnit = 1,
  businessUnit = 2,
}
